// @Version: 1.0.0
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TransformItemService {

   constructor () { }

   public transform (val: string | undefined): string[] {
      return val?.split(';').sort().map(value => value.substring(value.indexOf(':')+1)) ?? [];
   }
}
